{
  "library": {
    "categoryView": "Kategori",
    "filter": {
      "owner": "Ägare",
      "tags": "Taggar",
      "tiers": "Nivåer"
    },
    "header": "Bibliotek",

    "noDocumentVersionsFound": "Inga dokumentversioner hittades",
    "filterByTitlePlaceholder": "Filtrera på titel...",
    "columns": "Kolumner",
    "noResults": "Inga resultat.",
    "filters": {
      "before": "Före",
      "after": "Efter",
      "selectedCount": "{{count}} valda",
      "invalidDateRange": "Efter-datum måste vara före eller samma som Före-datum",
      "isBefore": "är före",
      "isAfter": "är efter",
      "isBetween": "är mellan",
      "equals": "är",
      "includes": "är en av",
      "notSet": "ej satt",
      "nullLabel": {
        "adoptedAt": "Ej antagen",
        "reviewFrom": "Ingen granskning från",
        "reviewTo": "Ingen granskning till"
      }
    },
    "pagination": {
      "navigation": "Sidnavigering",
      "previousPage": "Gå till föregående sida",
      "previous": "Föregående",
      "nextPage": "Gå till nästa sida",
      "next": "Nästa",
      "morePages": "Fler sidor",
      "showCount": "Visa {{count}}"
    },
    "onboardDocuments": {
      "header": "Onboarda dokument",
      "subtitle": "Följ guiden för att onboarda dina dokument till North House",
      "steps": {
        "upload": {
          "title": "Ladda upp dokument",
          "description": "Ladda upp flera dokument",
          "cardTitle": "Ladda upp dokument",
          "cardDescription": "Välj de styrdokument du vill onboarda.",
          "clickOrDrag": "Klicka eller dra filer för att ladda upp",
          "addMore": "Lägg till fler filer",
          "continue": "Fortsätt med {{count}} fil(er)",
          "unsupportedType": "\"{{name}}\" har en filtyp som inte stöds",
          "fileTooLarge": "\"{{name}}\" överskrider storleksgränsen på 50 MB",
          "duplicateFiles": "Redan uppladdade filer hoppades över"
        },
        "configure": {
          "title": "Ange plats i ditt ramverk",
          "description": "Placera varje dokument i kategori och nivå",
          "cardTitle": "Ange titel, nivå och kategori",
          "cardDescription": "Konfigurera grundläggande metadata för varje uppladdat dokument."
        },
        "fields": {
          "title": "Slutför onboardingen",
          "description": "Ange övriga fält och publicera dokumenten i North House",
          "cardTitle": "Ange ytterligare fält",
          "cardDescription": "Ange ägare, utgivare och andra fält, publicera sedan dina dokument."
        },
        "completion": {
          "cardTitle": "Dokument onboardade",
          "cardDescription": "Dina dokument har onboardats."
        }
      }
    }
  }
}
